import {has, is, prop} from 'ramda';

import type {SourcingVehicleListApiResponse} from '../types';

export function isSourcingVehicleListApiResponse(
  data: unknown
): data is SourcingVehicleListApiResponse {
  return is(Object, data) && has('data', data) && Array.isArray(prop('data', data));
}
